function formatUtcDate(currentDate: string, doNotUseUtc?: boolean) {
	if (!currentDate) {
		return currentDate;
	}

	const dateTimeSeparator = () => {
		if (currentDate.includes(' - ')) return ' - ';
		if (currentDate.includes('T')) return 'T';
		return ' ';
	};

	const [date, hours] = currentDate.split(dateTimeSeparator());

	if (!date || !hours) {
		return '';
	}

	const [day, month, year] = date.split('/');
	const [hourMinutesAndSeconds] = hours.split('-');
	const [hour, minute] = hourMinutesAndSeconds.split(':');

	if (doNotUseUtc) {
		return `${day}/${month}/${year} - ${hour}:${minute}`;
	}

	const utcDate = new Date(`${year}-${month}-${day}T${hourMinutesAndSeconds}-03:00`);

	const userTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

	const options: Intl.DateTimeFormatOptions = {
		timeZone: userTimeZone,
		hour12: false,
		year: 'numeric',
		month: '2-digit',
		day: '2-digit',
		hour: '2-digit',
		minute: '2-digit',
	};
	const formattedDate = new Intl.DateTimeFormat('pt-BR', options).format(utcDate);

	return formattedDate.replace(', ', ' - ');
}

export {formatUtcDate};
